(function () {
    'use strict';

    angular
        .module('app.mentionManagementLogDetailed', [])
        .controller('mentionManagementLogDetailedCtrl', ['$scope', '$rootScope', 'mentionManagementLogDetailedService', '$modal', '$modalInstance',
            function ($scope, $rootScope, mentionManagementLogDetailedService, $modal, $modalInstance) {
                
                $scope.closeModal = function() {
                	$modalInstance.close();
                }

                $scope.getMentionManagementLogDetailed = function(mention_management_log_id) {
                	mentionManagementLogDetailedService.getMentionManagementLogDetailed(mention_management_log_id, true)
                		.then(function(response) {
                			$scope.mentionManagementLogDetailed = response.data;
                		})
                }

                $scope.mentionDetail = function(mention_id) {
                    var mentionDetailsModalInstance = $modal.open({
                        scope: $scope,
                        templateUrl: 'app/admin/mention/mentions/mentionDetail/mentionDetail.html?app_v=deployDate',
                        controller: 'mentionDetailCtrl',
                    });
                    
                    $scope.id = mention_id;
                    $scope.mentionDetailsModalInstance = mentionDetailsModalInstance;
                }

                $scope.getMentionManagementLogDetailed($scope.mention_management_log_id);
            }
        ])
})();